import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, HandCoins } from "lucide-react";
import WhatsAppIcon from "../icons";
import { useLang } from "../../i18n";
import { useContent } from "../../lib/useContent";

export default function FloatingButtons() {
  const { t } = useLang();
  const c = useContent();
  const phoneRaw = c.phone.replace(/[\s-]/g, "");

  return (
    <motion.div
      data-testid="floating-buttons"
      initial={{ opacity: 0, x: 40 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1.2, duration: 0.6 }}
      className="fixed bottom-5 right-4 sm:right-5 z-40 flex flex-col gap-2.5"
    >
      <a
        data-testid="float-whatsapp"
        href={`https://wa.me/${c.social.whatsapp || "919452529739"}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("common.whatsapp")}
        className="wa-pulse w-12 h-12 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:-translate-y-1 hover:scale-105 transition-transform duration-300"
      >
        <WhatsAppIcon size={22} />
      </a>
      <a
        data-testid="float-call"
        href={`tel:${phoneRaw}`}
        aria-label={t("common.callNow")}
        className="w-12 h-12 rounded-full bg-ngo-gold text-ngo-ink flex items-center justify-center shadow-[0_8px_24px_rgba(216,169,40,0.45)] hover:-translate-y-1 transition-transform duration-300"
      >
        <Phone size={20} />
      </a>
      <Link
        data-testid="float-donate"
        to="/donate"
        aria-label={t("nav.donate")}
        className="w-12 h-12 rounded-full bg-ngo-deep text-white flex items-center justify-center shadow-[0_8px_24px_rgba(23,107,58,0.5)] hover:-translate-y-1 hover:scale-105 transition-transform duration-300"
      >
        <HandCoins size={20} />
      </Link>
    </motion.div>
  );
}
